import { useEffect } from "react";
import { MotionConfig } from "framer-motion";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import "@/App.css";
import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import ProofStrip from "@/components/sections/ProofStrip";
import Cases from "@/components/sections/Cases";
import Process from "@/components/sections/Process";
import Founder from "@/components/sections/Founder";
import Pricing from "@/components/sections/Pricing";
import FAQ from "@/components/sections/FAQ";
import FinalCTA from "@/components/sections/FinalCTA";
import Footer from "@/components/sections/Footer";
import WhatsAppButton from "@/components/sections/WhatsAppButton";
import Projects from "@/pages/Projects";

function Home() {
  return (
    <>
      <Hero />
      <ProofStrip />
      <Cases />
      <Founder />
      <Process />
      <Pricing />
      <FAQ />
      <FinalCTA />
    </>
  );
}

// Client-side navigation keeps the old scroll position: jump to the requested
// section, or to the top of a new page.
function useScrollOnNavigate() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    const target = hash && document.getElementById(hash.slice(1));
    if (target) target.scrollIntoView();
    else window.scrollTo(0, 0);
  }, [pathname, hash]);
}

function App() {
  useScrollOnNavigate();
  return (
    <MotionConfig reducedMotion="user">
      <div className="min-h-[100dvh] overflow-x-clip bg-background">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/projetos" element={<Projects />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton />
      </div>
    </MotionConfig>
  );
}

export default App;
